import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const FilterIcon = (properties: iconType) => {
  const { width, height, stroke } = properties;
  return (
    <SvgIcon
      {...properties}
      viewBox="0 0 16 9"
      style={{ width: width || '16', height: height || '9' }}
    >
      <path
        d="M8.14686 0.999999C11.9817 0.999999 15 4.75 15 4.75C15 4.75 12.0205 8.5 8.14686 8.5C4.27326 8.5 1 4.73646 1 4.73646C1 4.73646 4.17407 0.999999 8.14686 0.999999Z"
        fill="none"
      />
      <path
        d="M8.25 2C6.73122 2 5.5 3.23122 5.5 4.75C5.5 6.26878 6.73122 7.5 8.25 7.5C9.76878 7.5 11 6.26878 11 4.75C11 3.23122 9.76878 2 8.25 2Z"
        fill={stroke}
        stroke="none"
      />
    </SvgIcon>
  );
};

FilterIcon.defaultProperties = {
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#78869E',
};

export default FilterIcon;
